export const parsingBankUrl = [
  {
    id: '우리은행',
    url: 'https://sbiz.wooribank.com/biz/jcc?withyou=BZFXD0021&__ID=c008439',
  },
  {
    id: 'KB국민은행',
    url: 'https://obank.kbstar.com/quics?page=C101423#CP',
  },
  {
    id: '신한은행',
    url: 'https://bank.shinhan.com/index.jsp#020501010100',
  },
  {
    id: '하나은행',
    url: 'https://www.kebhana.com/cms/rate/wpfxd651_01i_01.do?ajax=true&curCd=&pbldDvCd=3&pbldSqn=&inqKindCd=1&requestTarget=searchContentDiv',
  },
  {
    id: '농협은행',
    url: 'https://banking.nonghyup.com/index_todayExchange.html',
  },
  {
    id: 'IBK기업은행',
    url: 'https://www.ibk.co.kr/fxtr/excRateList.ibk?pageId=SM03020100',
  },
  {
    id: '한국씨티은행',
    url: 'https://www.citibank.co.kr/m/FxdExrtFxrt0100.act',
  },
  {
    id: '스탠다드차티드',
    url: 'https://www.standardchartered.co.kr/np/kr/pl/et/ExchangeRateP1.jsp',
  },
  {
    id: '수협은행',
    url: 'https://biz.suhyup-bank.com/ib20/mnu/CBM01871',
  },
];
